<template>
    <div class="pay-container">
        <head-bar title="选择支付方式" :fixed="true"></head-bar>
        <div class="info-box">
            <div class="info-item">
                <span>订单号:&nbsp;{{ orderInfo.orderNumber }}</span>
            </div>
            <div class="info-item">
                <span>应付金额:&nbsp;</span>
                <em>¥{{ orderInfo.orderPrice }}</em>
            </div>
            <div class="info-item">
                <span>剩余支付时间:&nbsp;</span>
                <em>{{ times }}</em>
            </div>
        </div>
        <div class="pay-type-box">
            <div
                class="pay-type-item"
                :key="index"
                v-for="(item, index) in payOptions"
                @click="() => selectPayType(item, index)"
            >
                <span>{{ item.name }}</span>
                <span :class="item.classNamesList"
                    >({{ item.description }})</span
                >
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import HeadBar from "@/components/HeadBar.vue";
import utils from "@/utils/utils";
import { Toast, Dialog } from "vant";
import { isEmpty } from "../../utils/validation";
Vue.use(Toast);
import {
    online_payment,
    offline_payment,
    wallet_payment,
    trade_wechat,
    trade_ali,
    trade_bank,
    trade_remittance,
    trade_wallet,
} from "../../definition/type/pay";

import {
    wallet_status_not_opened,
    wallet_status_feoze,
    wallet_status_unsubscribe,
    wallet_status_lock,
    wallet_status_normal,
    wallet_status_insufficient,
} from "../../definition/status/wallet";

const typeOptions = [
    {
        name: "线上支付",
        description: "微信,支付宝等支付",
        disabled: false,
        payType: online_payment,
        tradeType: trade_wechat,
        classNamesList: {
            active: false,
            disabled: false,
        },
    },
    {
        name: "公对公支付",
        description: "线下银行支付",
        disabled: false,
        payType: offline_payment,
        tradeType: trade_remittance,
        classNamesList: {
            active: false,
            disabled: false,
        },
    },
    {
        name: "钱包支付",
        description: "",
        disabled: false,
        payType: wallet_payment,
        tradeType: trade_wallet,
        classNamesList: {
            active: false,
            disabled: false,
        },
    },
];

function combinationPayOptions(source, walletInfo) {
    if (!Array.isArray(source)) return [];
    let temp = [];
    let {
        walletState,
        cashBalance = 0,
        waitCreditBalance = 0,
        walletUsable = false,
    } = walletInfo;
    source.forEach((item, index) => {
        let { payType } = item;
        if (payType != wallet_payment) {
            temp.push({ ...item });
        } else if (payType === wallet_payment) {
            let description = "";

            item.disabled = !walletUsable;

            item.classNamesList.disabled = !walletUsable;

            if (!isEmpty(cashBalance) && typeof cashBalance === "number") {
                description = `余额¥${cashBalance}`;
            }

            if (
                isEmpty(waitCreditBalance) &&
                walletUsable == false &&
                waitCreditBalance > 0
            ) {
                item.classNamesList.active = true;
            }

            if (walletState == wallet_status_not_opened) {
                description = "未开通";
                item.disabled = true;
            }

            if (walletState == wallet_status_unsubscribe) {
                description = "注销";
            }
            item.description = description;

            temp.push(item);
        }
    });
    return temp;
}

export default {
    name: "PaySelect",
    components: {
        HeadBar,
    },
    created() {
        let { orderNo, orderPrice } = this.$route.query;
        if (isEmpty(orderNo)) {
            this.$router.push("/");
            return false;
        }
        this.orderInfo.orderPrice = orderPrice;
        this.orderInfo.orderNumber = orderNo;
        this.queryOrderWalletBalance(orderNo);
        this.queryOrderCountDown(orderNo);
    },
    data() {
        return {
            orderInfo: {
                orderNumber: "",
                orderPrice: 0,
            },
            payOptions: typeOptions,
            times: "00:00:00",
            hideForm: true,
            isLoad: false,
        };
    },
    methods: {
        queryOrderWalletBalance(orderNo) {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let _this = this;
            let url = this.$api.userApi.queryOrderWalletBalance;
            this.$axios
                .post(url, {
                    context: {
                        orderNo,
                    },
                })
                .then((response) => {
                    let { data: walletInfo } = response;
                    _this.payOptions = combinationPayOptions(
                        typeOptions,
                        walletInfo
                    );
                })
                .catch(() => {
                    _this.$router.push("/");
                })
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 查询订单倒计时
         */
        queryOrderCountDown(orderNo) {
            let url = this.$api.orderApi.order_getOrderCancelTime;
            let _this = this;
            this.$axios
                .post(url, {
                    orderNo: orderNo,
                })
                .then((response) => {
                    let { data: seconds = 0 } = response;
                    utils.countDownConversion(seconds, (times, isEnd) => {
                        _this.times = times;
                        if (isEnd) {
                            _this.$router.push("/");
                        }
                    });
                })
                .catch(() => {
                    _this.$router.push("/");
                });
        },
        /**
         * @description 选择订单支付方式
         */
        async selectPayType(item) {
            let { disabled, payType, tradeType } = item;
            let _this = this;
            if (!disabled && !this.isLoad) {
                try {
                    let { orderNo } = this.$route.query;
                    let { orderPrice } = this.orderInfo;
                    let updatePayTypeUrl = this.$api.orderApi
                        .order_updatePayType;
                    let queryPaymentPriceIsModifUrl = this.$api.payApi
                        .queryPaymentPriceIsModif;
                    this.isLoad = true;
                    this.$toast.loading({
                        message: "数据加载中...",
                        duration: 0,
                    });
                    let {
                        data: { isAlter = false, orderAmount = 0 },
                    } = await this.$axios.post(queryPaymentPriceIsModifUrl, {
                        context: {
                            orderNo: orderNo,
                            payAmount: orderPrice,
                        },
                    });
                    if (isAlter) {
                        _this.isLoad = false;
                        _this.$toast.clear();
                        _this.$toast("订单价格已更新");
                        _this.orderInfo.orderPrice = orderAmount;
                        return;
                    }
                    await _this.$axios.post(updatePayTypeUrl, {
                        orderNo: orderNo,
                        payType: payType,
                        payTradeType: tradeType,
                    });
                    _this.isLoad = false;
                    _this.$toast.clear();
                    _this.goToPayPage(payType);
                } catch (error) {
                    let { msg } = error;
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                    _this.isLoad = false;
                    _this.$toast.clear();
                }

                // this.$axios
                //     .post(url, {
                //         orderNo: orderNo,
                //         payType: payType,
                //         payTradeType: tradeType,
                //     })
                //     .then(() => {
                //         _this.goToPayPage(payType);
                //     })
                //     .catch(({ msg }) => {
                //         _this.isLoad = false;
                //         if (!isEmpty(msg)) {
                //             _this.$toast(msg);
                //         }
                //     })
                //     .finally(() => {
                //         _this.isLoad = false;
                //         _this.$toast.clear();
                //     });
            }
        },
        goToPayPage(payType) {
            let { orderNo, invoiceId = "", orderId = "" } = this.$route.query;
            let { orderPrice } = this.orderInfo;
            let targetPageMap = {
                [online_payment]: "/pay/online",
                [offline_payment]: "/pay/remittance",
                [wallet_payment]: "/pay/wallet",
            };
            let targetPageUrl = targetPageMap[payType];
            this.$router.push({
                path: targetPageUrl,
                query: {
                    orderNo: orderNo,
                    orderId: orderId,
                    orderPrice: orderPrice,
                    invoiceId: invoiceId,
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.pay-container {
    width: 750px;
    padding-top: 92px;
    .info-box {
        padding: 60px 40px;
        background-color: #fff;
        .info-item {
            margin-bottom: 5px;
            font-size: 28px;
            line-height: 40px;
            color: #333;
        }
        em {
            font-weight: 600;
            color: #ff5500;
        }
    }
    .pay-type-box {
        margin: 20px 0px;
        padding: 0 30px;
        background-color: #fff;
        .pay-type-item {
            height: 110px;
            border-bottom: 1px solid #f2f2f2;
            font-size: 0px;
            line-height: 110px;
            text-align: center;
            &:last-child {
                border: none;
            }

            .base-icon {
                *display: inline;
                display: inline-block;
                zoom: 1;
                margin-right: 20px;
                vertical-align: -20px;
                width: 56px;
                height: 56px;
                background-size: 56px;
                background-repeat: no-repeat;
                background-position: center;
                &.wechat-icon {
                    background-image: url("../../public/images/pay/wechat-pay-icon.png");
                }
                &.alipay-icon {
                    background-image: url("../../public/images/pay/alipay-pay-cion.png");
                }
            }
            span {
                font-size: 28px;
                color: #333;
                &.disabled {
                    color: #999;
                }
                &.active {
                    color: #ff5500;
                }
            }
        }
    }
}
</style>
